import { isNumber } from 'lodash';
import { formatPrice } from './quotes/priceFormatter';
import React from 'react';
import classNames from 'classnames';

function priceToText(price, isNegative) {
  if (!isNumber(price)) return price;

  return formatPrice(price * (isNegative ? -1 : 1));
}

const Price = ({
  label,
  property,
  valueDNet,
  valueMsrp,
  isNegative,
  hide,
  msrpClassNames,
  dNetClassNames,
}) => {
  if (hide) {
    return null;
  }
  if ((valueDNet || valueMsrp) && property) {
    throw Error(
      "Can't both, 'property' and 'valueDNet/valueMsrp' be provided at the same time"
    );
  }

  const price = priceToText(valueDNet, isNegative);

  const msrp = isNegative ? 'N/A' : priceToText(valueMsrp, isNegative);

  return (
    <div
      className={
        'row justify-content-end' +
        (label.toLowerCase() === 'total' ? ' totalPrice ' : '')
      }
    >
      <h5 className="col-6 quote-price-label">{label}</h5>
      <h5 className={classNames('quote-price-value', msrpClassNames)}>
        {msrp}
      </h5>
      <h5 className={classNames('quote-price-value', dNetClassNames)}>
        {price}
      </h5>
    </div>
  );
};

export default Price;
